import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const ScribeRegenerateModal = ({ isOpen, onClose, onConfirm, consultation, loading, getPatientName }) => {
  if (!isOpen || !consultation) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Regenerate Consultation</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to regenerate this consultation?</p>
          <div className="document-details">
            <div className="detail-row">
              <span className="detail-label">Patient:</span>
              <span className="detail-value">{getPatientName(consultation.nhsId) || consultation.nhsId || 'Unknown'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Created:</span>
              <span className="detail-value">
                {consultation.timestamp ? new Date(consultation.timestamp).toLocaleString() : 'Unknown'}
              </span>
            </div>
          </div>
          <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
            This will create new AI-generated content for the consultation, replacing the current content.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="regenerate-confirm-button" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              'Regenerate'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScribeRegenerateModal;
